module.exports = __webpack_public_path__ + "static/about-img-82b066a50afc14cb4739a0d3843fbdc8.jpg";